import { StripeSupportedCountryCode } from "./types/StripeSupportedCountryCode.types.js";

export const FIFTY_AFFILIATES = 50;
export const NUMBER_PAYING_AFFILIATES_FOR_TRANSFER = 1;
export const OTHER_COUNTRIES_CODE = "XX";

export const WAAPI_LEGAL_ENTITY = {
    name: "Waapi",
    legalForm: "SAS",
    addressLine: "290 avenue Nina Simone",
    postalCode: "34070",
    city: "Montpellier",
    country: "France",
    vatNumber: "FR47841124001",
    rcs: "RCS Montpellier 841124001",
    capital: "130 000,00 EUR",
    naf: "5829C",
} as const;
export const WAALAXY_EMAIL = "no-reply@waalaxy.com";
export const WAALAXY_DISPLAY_NAME = "Waalaxy";
export const AFFILIATE_EXPORT_MAIL_SUBJECT = "Affiliates export";
export const AFFILIATE_EXPORT_MAIL_TEXT = "Find attached a CSV containing your affiliates data.";
export const AFFILIATE_EXPORT_ATTACHMENT_NAME = "export_affiliates.csv";
export const AFFILIATE_EXOPORT_ATTACHMENT_TYPE = "text/plain";
export const STRIPE_SUPPORTED_COUNTRIES_CODES = [
    "DE",
    "AU",
    "AT",
    "BE",
    "BG",
    "CA",
    "CY",
    "ES",
    "EE",
    "FR",
    "GI",
    "GR",
    "HU",
    "IE",
    "IT",
    "JP",
    "LI",
    "LV",
    "LT",
    "LU",
    "MT",
    "MX",
    "NZ",
    "NL",
    "PL",
    "PT",
    "HK",
    "RO",
    "GB",
    "CZ",
    "SG",
    "SK",
    "SI",
    "CH",
    "AE",
    "US",
] as const;
export const OTHER_COUNTRIES_CODES = [
    "AF",
    "AL",
    "DZ",
    "AS",
    "AD",
    "AO",
    "AI",
    "AQ",
    "AG",
    "AR",
    "AM",
    "AW",
    "AZ",
    "BS",
    "BH",
    "BD",
    "BB",
    "BY",
    "BZ",
    "BJ",
    "BM",
    "BT",
    "BO",
    "BA",
    "BW",
    "BV",
    "BR",
    "IO",
    "BN",
    "BF",
    "BI",
    "KH",
    "CM",
    "CV",
    "KY",
    "CF",
    "TD",
    "CL",
    "CN",
    "CX",
    "CC",
    "CO",
    "KM",
    "CG",
    "CD",
    "CK",
    "CR",
    "CI",
    "HR",
    "CU",
    "DK",
    "DJ",
    "DM",
    "DO",
    "EC",
    "EG",
    "SV",
    "GQ",
    "ER",
    "ET",
    "FK",
    "FO",
    "FJ",
    "FI",
    "GF",
    "PF",
    "TF",
    "GA",
    "GM",
    "GE",
    "GH",
    "GL",
    "GD",
    "GP",
    "GU",
    "GT",
    "GN",
    "GW",
    "GY",
    "HT",
    "HM",
    "VA",
    "HN",
    "IS",
    "IN",
    "ID",
    "IR",
    "IQ",
    "IL",
    "JM",
    "JO",
    "KZ",
    "KE",
    "KI",
    "KP",
    "KR",
    "KW",
    "KG",
    "LA",
    "LB",
    "LS",
    "LR",
    "LY",
    "ME",
    "MO",
    "MK",
    "MG",
    "MW",
    "MY",
    "MV",
    "ML",
    "MH",
    "MQ",
    "MR",
    "MU",
    "YT",
    "FM",
    "MD",
    "MC",
    "MN",
    "MS",
    "MA",
    "MZ",
    "MM",
    "NA",
    "NR",
    "NP",
    "NC",
    "NI",
    "NE",
    "NG",
    "NU",
    "NF",
    "MP",
    "NO",
    "OM",
    "PK",
    "PW",
    "PS",
    "PA",
    "PG",
    "PY",
    "PE",
    "PH",
    "PN",
    "PR",
    "QA",
    "RE",
    "RU",
    "RW",
    "SH",
    "KN",
    "LC",
    "PM",
    "VC",
    "WS",
    "SM",
    "ST",
    "SA",
    "SN",
    "RS",
    "SC",
    "SL",
    "SX",
    "SB",
    "SO",
    "ZA",
    "GS",
    "SS",
    "LK",
    "SD",
    "SR",
    "SJ",
    "SZ",
    "SE",
    "SY",
    "TW",
    "TJ",
    "TZ",
    "TH",
    "TL",
    "TG",
    "TK",
    "TO",
    "TT",
    "TN",
    "TR",
    "TM",
    "TC",
    "TV",
    "UG",
    "UA",
    "UM",
    "UY",
    "UZ",
    "VU",
    "VE",
    "VN",
    "VG",
    "VI",
    "WF",
    "EH",
    "YE",
    "ZM",
    "ZW",
    "JP",
    "AU",
    "CA",
    "MX",
    "NZ",
    "HK",
    "SG",
    "US",
    "AE",
];
export const countryToCurrencyMap: Record<StripeSupportedCountryCode, string> = {
    DE: "EUR",
    AU: "AUD",
    AT: "EUR",
    BE: "EUR",
    BG: "BGN",
    CA: "CAD",
    CY: "EUR",
    ES: "EUR",
    EE: "EUR",
    FR: "EUR",
    GI: "GIP",
    GR: "EUR",
    HU: "HUF",
    IE: "EUR",
    IT: "EUR",
    JP: "JPY",
    LI: "CHF",
    LV: "EUR",
    LT: "EUR",
    LU: "EUR",
    MT: "EUR",
    MX: "MXN",
    NZ: "NZD",
    NL: "EUR",
    PL: "PLN",
    PT: "EUR",
    HK: "HKD",
    RO: "RON",
    GB: "GBP",
    CZ: "CZK",
    SG: "SGD",
    SK: "EUR",
    SI: "EUR",
    CH: "CHF",
    AE: "AED",
    US: "USD",
};
